import {
  getNetworkTrackingPropertyGroup,
  getDealerTrackingPropertyGroup,
} from 'app/dealer/utils';
import { trackAction } from 'app/shared/utils/tracking';
import {
  TOP_LISTINGS_CATEGORIES,
  ListingsBenchmarkTopListingsActionTypes,
} from 'app/dealer/dashboard/Dashboard/ListingsBenchmark/redux/topListings/constants';

// NOTE: using static strings so tracking script can pick up this data for the TRACKING doc

// expected names from event_tracking excel sheet
export const TOP_LISTINGS_TRACKING_CATEGORIES = {
  LEADS: 'leads',
  FAVORITES: 'favorites',
  CLICKS: 'clicks',
};

/**
 * @typedef {'[ListingsBenchmark Top Listings] CLICK TOP LISTINGS CAR TILE'|'[ListingsBenchmark Top Listings] SET ACTIVE CATEGORY'|'[ListingsBenchmark Top Listings] TOGGLE CATEGORY DROPDOWN'} TopListingsTrackingAction
 * */

/**
 * @enum {TopListingsTrackingAction}
 */
export const TOP_LISTINGS_TRACKING_ACTIONS = {
  TOGGLE_DROPDOWN:
    ListingsBenchmarkTopListingsActionTypes.TOGGLE_CATEGORY_DROPDOWN,
  SELECT_CATEGORY:
    ListingsBenchmarkTopListingsActionTypes.SET_ACTIVE_TOP_LISTINGS_CATEGORY,
  CAR_TILE_CLICK:
    ListingsBenchmarkTopListingsActionTypes.CLICK_TOP_LISTINGS_CAR_TILE,
};

/**
 * @description matches app's categories to expected tracking labels
 * @param {import('../../redux/reducer.initialData').ListingsBenchmarkTopListingsCategory} category
 * @returns {'leads'|'favorites'|'clicks'|''}
 */
export const getTrackingLabelName = category => {
  switch (category) {
    case TOP_LISTINGS_CATEGORIES.byLeads:
      return TOP_LISTINGS_TRACKING_CATEGORIES.LEADS;
    case TOP_LISTINGS_CATEGORIES.byFavourites:
      return TOP_LISTINGS_TRACKING_CATEGORIES.FAVORITES;
    case TOP_LISTINGS_CATEGORIES.byViews:
      return TOP_LISTINGS_TRACKING_CATEGORIES.CLICKS;
    default:
      return '';
  }
};

/**
 * Required params to track a filtered dealer location level action
 *
 * @typedef {Object} TopListingsTrackingParams
 * @property {import('../../../../../../account/Network/reducer').Network} network
 * @property {Object} dealer // TODO: type def
 * @property {TopListingsTrackingAction} action
 * @property {'leads'|'favorites'|'clicks'} [topListingsCategory]
 */

/**
 * @param {TopListingsTrackingParams} param0
 * @returns {void}
 */
export const trackTopListings = ({
  network,
  dealer,
  actionType,
  topListingsCategory,
}) => {
  let additionalProperties = {
    ...getNetworkTrackingPropertyGroup(network),
  };
  if (dealer) {
    additionalProperties = {
      ...additionalProperties,
      ...getDealerTrackingPropertyGroup(dealer),
    };
  }

  const label = getTrackingLabelName(topListingsCategory);
  switch (actionType) {
    case TOP_LISTINGS_TRACKING_ACTIONS.TOGGLE_DROPDOWN:
      trackAction(
        'dashboard_listings_top_listings_dropdown',
        {
          category: 'dealer_portal',
          description: 'user clicks into top listings drop down',
          label,
        },
        additionalProperties,
      );
      break;
    case TOP_LISTINGS_TRACKING_ACTIONS.SELECT_CATEGORY:
      trackAction(
        'dashboard_listings_top_listings_dropdown_selection',
        {
          category: 'dealer_portal',
          description: 'user clicks into dropdown to change the view for Top Listings based on leads clicks or favorites',
          label,
        },
        additionalProperties,
      );
      break;
    case TOP_LISTINGS_TRACKING_ACTIONS.CAR_TILE_CLICK:
      trackAction(
        'dashboard_listings_top_listings_cartile',
        {
          category: 'dealer_portal',
          description: 'user clicks on Car tile of Top listings to get to PDP',
          label,
        },
        additionalProperties,
      );
      break;
    default:
      break;
  }
};
